export const DASHBOARD_REPORT_ENDPOINTS = {
  'All Calls': '/visits/reports/all-calls',
  'All Visits': '/visits/reports/all-visits',
  'Expired Visits': '/visits/reports/expired-visits',
  'Visits Per Day': '/visits/reports/visits-per-day',
  Classification: '/user-customers/reports/classification',
  'Calls Locations': '/trackers/reports/calls',
  'Customers With Geo Location': '/user-customers/reports/geolocation',
  'Sales Reps Productivity': '/visits/reports/rep-productivity',
  'Promoters Report': '/promoter-sales/reports/promoters',
  'Supervisors KPIs': '/visits/reports/supervisor-performance',
  'Supervisors KPIs Expanded': '/visits/reports/supervisor-performance-details',
  'Managers Activities': '/visits/reports/managers-activities',
  'Call Rate/Targeted Call Rate': '/visits/reports/call-rate',
  'Visit Rate/Targeted Visit Rate': '/visits/reports/visit-rate',
  'Rep Average Call Duration': '/visits/reports/call-duration',
  'Double Visits': '/visits/reports/double-visits',
  'Rep Plans': '/plans/reports/rep-plans',
  'Supervisor Plans': '/plans/reports/supervisor-plans',
  'Plan Draft': '/plan-drafts/report/rep-plan-drafts',
  'Customers Plan Draft': '/plan-drafts/report/customers-plan-drafts',
  Orders: '/orders/reports/all-orders',
  Expenses: '/expenses/reports/all-expenses',
  Attendance: '/trackers/reports/promoters-attendance',
  KPIs: '/visits/reports/kpis',
  'Target Frequency': '/visits/reports/target-frequency',
  'Monthly coverage': '/visits/reports/monthly-coverage',
} as const;

export type DashboardReportKey = keyof typeof DASHBOARD_REPORT_ENDPOINTS;

export const REPORTS_FOR_MANAGEMENT: DashboardReportKey[] = [
  'All Calls',
  'All Visits',
  'Expired Visits',
  'Visits Per Day',
  'Classification',
  'Calls Locations',
  'Customers With Geo Location',
  'Sales Reps Productivity',
  'Promoters Report',
  'Supervisors KPIs',
  'Supervisors KPIs Expanded',
  'Managers Activities',
  'Call Rate/Targeted Call Rate',
  'Visit Rate/Targeted Visit Rate',
  'Rep Average Call Duration',
  'Double Visits',
  'Rep Plans',
  'Supervisor Plans',
  'Plan Draft',
  'Customers Plan Draft',
  'Orders',
  'Expenses',
  'Attendance',
  'Target Frequency',
  'Monthly coverage'
];

export const REPORTS_FOR_REP: DashboardReportKey[] = [
  'All Calls',
  'All Visits',
  'Expired Visits',
  'Visits Per Day',
  'Classification',
  'Calls Locations',
  'Customers With Geo Location',
  'Sales Reps Productivity',
  'Promoters Report',
  'Supervisors KPIs',
  'Supervisors KPIs Expanded',
  'Call Rate/Targeted Call Rate',
  'Visit Rate/Targeted Visit Rate',
  'Rep Average Call Duration',
  'Double Visits',
  'Rep Plans',
  'Plan Draft',
  'Customers Plan Draft',
  'Orders',
  'Expenses',
  'Attendance',
  'Target Frequency',
  'Monthly coverage'
];

export const REPORTS_DERMAZONE_EXTRA: DashboardReportKey = 'KPIs';

/**
 * Configuration for visits breakdown by customer type
 */
export const VISITS_BREAKDOWN_CONFIG = [
  { type: 'Doctor' as const, icon: 'iconoirUser', title: 'Doctor' },
  { type: 'Provider' as const, icon: 'iconoirGroup', title: 'Provider' },
  { type: 'Pharmacy' as const, icon: 'iconoirHandbag', title: 'Pharmacy' },
  { type: 'Hospital' as const, icon: 'iconoirHealthShield', title: 'Hospital' },
] as const;
